import type { PartnerName, PartnerParams } from "@ascent/papi-core";
import type { PartnerHandlerContext, PartnerModule } from "../types/partner";

export const partnerModulesConfig: Record<
  PartnerName,
  {
    loader: () => Promise<PartnerModule>;
    handlerName: string;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    getHandlerArgs: (params: any, ctx: PartnerHandlerContext) => any[];
  }
> = {
  taboola: {
    loader: () => import("./taboola"),
    handlerName: "sendTaboolaEvent",
    getHandlerArgs: (
      params: Extract<PartnerParams, { partner: "taboola" }>,
    ) => [params.id, params.event],
  },
  tiktok: {
    loader: () => import("./tiktok"),
    handlerName: "sendTikTokEvent",
    getHandlerArgs: (params: Extract<PartnerParams, { partner: "tiktok" }>) => [
      params.id,
      params.event,
      params.eventID,
    ],
  },
  zemanta: {
    loader: () => import("./zemanta"),
    handlerName: "sendZemantaEvent",
    getHandlerArgs: (
      params: Extract<PartnerParams, { partner: "zemanta" }>,
    ) => [params.id, params.event],
  },
  facebook: {
    loader: () => import("./facebook"),
    handlerName: "sendFacebookEvent",
    getHandlerArgs: (
      params: Extract<PartnerParams, { partner: "facebook" }>,
    ) => [params.id, params.event, params.ldu, params.eventID],
  },
  snapchat: {
    loader: () => import("./snapchat"),
    handlerName: "sendSnapchatEvent",
    getHandlerArgs: (
      params: Extract<PartnerParams, { partner: "snapchat" }>,
    ) => [params.id, params.event, params.eventID],
  },
  google: {
    loader: () => import("./google"),
    handlerName: "sendGTMEvent",
    getHandlerArgs: (
      params: Extract<PartnerParams, { partner: "gtm" }>,
      ctx: PartnerHandlerContext,
    ) => [
      params.propertyId1,
      params.propertyId2,
      params.conversionId,
      ctx.pageId,
    ],
  },
  outbrain: {
    loader: () => import("./outbrain"),
    handlerName: "sendOutbrainEvent",
    getHandlerArgs: (
      params: Extract<PartnerParams, { partner: "outbrain" }>,
    ) => [params.id, params.event],
  },
};
